import { ShipmentIssueType, ShipmentIssueCategory } from 'apps/marketplace/apiTypes/shipmentIssues'

export interface ShipmentIssueTypeCategory extends ShipmentIssueType {
  categoryName: string | null
}

const filterIssueTypes = (
  issueTypes: ShipmentIssueType[],
  searchTerm: String,
  categories: ShipmentIssueCategory[]
) =>
  issueTypes
    .map(issueType => {
      const category = categories.find(
        ({ id: categoryId }) => issueType.shipmentIssueCategoryId === categoryId
      )

      return {
        ...issueType,
        categoryName: category?.name || null,
      }
    })
    .filter(issueType => {
      const { categoryName = '', description = '', id, name = '' } = issueType

      const formattedSearchTerm = searchTerm.toLowerCase()

      return (
        name.toLowerCase().includes(formattedSearchTerm) ||
        description?.toLowerCase().includes(formattedSearchTerm) ||
        categoryName?.toLowerCase().includes(formattedSearchTerm) ||
        `${id}` === formattedSearchTerm
      )
    })

export default filterIssueTypes
